import React from 'react';

import Stage from '../shared/field_inputs/pipeline/stage/Stage';

const PipelineSummarySlim = ({ value, stages }) => {
    const index = value ? stages.findIndex((s) => s.id === value) : 0;

    return (
        <div className='crm-editable-field-wrapper'>
            <div className='pipeline-stages open'>
                <ul>
                    {stages.map((s, i) => (
                        <Stage
                            key={s.id}
                            pipelineStage={s}
                            highlighted={i <= index}
                            hasArrow={i < stages.length - 1}
                            onClick={() => console.log('no')}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default PipelineSummarySlim;